import { Bug, Megaphone, MessageSquareHeart } from 'lucide-react';
import { createWebRegistrationFromManifest } from '@reflex/plugin-api/create-web-registration';
import { feedbackWeb } from '../web-manifest.js';

export default createWebRegistrationFromManifest(
  feedbackWeb,
  {
    FeedbackPopover: () => import('./FeedbackPopover'),
    FeedbackAgentAction: () => import('./FeedbackAgentAction'),
    FeedbackSetupPanel: () => import('./FeedbackSetupPanel'),
    MyFeedbackPage: () => import('./MyFeedbackPage'),
  },
  {
    icons: { Bug, Megaphone, MessageSquareHeart },
  },
);
